import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservationSoftware/Load',
      params,
    });
  },
  // 取消預約
  CancelReservation(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StudentReservationSoftware/CancelReservation',
      data,
    });
  },
  // 報到
  Signup(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StudentReservationSoftware/Signup',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  // 補簽到/取消簽到
  ChangeSignup(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StudentReservationSoftware/ChangeSignup',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  // 靠卡報到
  CardSignup(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StudentReservationSoftware/CardSignup',
      headers: { 'Content-Type': 'application/json' },
      data,
    });
  },
  CertifiHours(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservationSoftware/CertifiHours',
      params,
    });
  },
};
